export function updateFilterUrl(selectedFilters, currentPage){
    let filterUrl = '';
    let count = 0;
    let page = 0;

    selectedFilters.forEach((selected_filter) => {
        let filter_name = selected_filter.name,
            filter_values = [];



        selected_filter.elements.forEach((element) => {
            if (element.selected){
                filter_values.push(element.id);
            }
        })
        if (filter_values.length){
            if (count > 0){
                filterUrl += '&';
            } else {
                filterUrl += '#';
            }
            filterUrl += filter_name + '=' + filter_values.toString();
            count += 1;
        }

    })

    if (count > 0){
      filterUrl += '&page=' + currentPage;

    } else {
      filterUrl += '#page=' + currentPage;
    }
    window.history.pushState(null, null, filterUrl);
  }


  export function parseFilterUrl(form){
    let hash =  window.location.hash;

    let data = {
      'form' : form,
      'page' : 1
    }

    data.form.map((form_section) => {

          let all = {
            name: 'all',
            title: "All",
            parent: form_section.name,
            id: 99999999,
            selected: false
          }
          form_section.elements.unshift(all);

    })

    if (!hash.length)
        return data;

    let params = hash.split("#")[1].split("&");

    params.forEach((param, i)=> {
        const v = param.split("=");
        if (v[0] === "page"){
          data.page = parseInt(v[1]);
        }
        else {

          data.form.map((form_section) => {
            if (form_section.name === v[0]){
                let any_selected = false;
                form_section.elements.map((element) => {
                    if (v[1].indexOf(element.id) > -1){
                        element.selected = true;
                        any_selected = true;
                    }
                })
                if (!any_selected){
                  form_section.elements[0].selected = true;
                }

            }
          })
        }
    });




    return data;

  }
